import React from "react";
import Type from "../Data/Type";

function Header() {
  return (
    <section>
      <header>
        <div className="row">
          <div
            className="header-content"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <h1>
              Hy! I Am <br />
              <span className="name">Sah Kwadwo Daniel.</span>
              <div>
                I'm a{" "}
                <span className="typed">
                  <Type />
                </span>
              </div>
            </h1>
            <p>
              Resourceful Full stack web developer bringing in-depth knowledge
              of latest technology trends to produce excellent web applications.
            </p>
            <div className="button">
              <a href="#contact-section" className="btn-full">
                Hire Me &rarr;
              </a>
            </div>
          </div>
          <div className="header-image" data-aos="zoom-in" data-aos-delay="200">
            <img src="/header.svg" alt="" />
          </div>
        </div>
        <div className="backdrop-obj"></div>
      </header>
    </section>
  );
}

export default Header;
